import React, { useState, useEffect } from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import FileUpload from '@techsoftware/happay-widgets/FileUpload';
import {
  isMobile,
  currencyFormatter,
  decimalFormatter,
  formatDate,
} from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import TrackWorkflow from '../../TrackWorkflow';
import BottomActions from '../../bottomActions';
import ContainerView from '../../ContainerView';
import Declaration from '../../customComponent/declaration';
import ReschedulePayment from '../../../containers/rescheduleInvoiceContainer';
import CancelPayment from '../../../containers/cancelPaymentContainer';
import { invoiceScheduleAfterPaymentTime } from '../../../utils/common';

export default function InvoiceDetail({
  invoiceDetails = {},
  viewType,
  workflowDetails = {},
  workflowContainerAction,
  submitInvoice,
  from,
  getWorkflowComments,
  comment,
  currencyList = [],
  userInfo,
  rescheduleInvoice,
  saveAndSubmitInvoice,
}) {
  const [state, setState] = useState({});
  const { invoice = {} } = invoiceDetails;

  const {
    twf_states = [],
    stateSetting: { item_action_status_map } = {},
    resource_id,
    twf_id,
    is_completed: isCompleted,
    is_blocked: isBlocked
  } = workflowDetails;

  const istrackWorkflowVisible = twf_states.length > 0;
  const isRequesterApproverDiff =
    userInfo?.happay_id !== workflowDetails?.requestor?.happay_id;

  useEffect(() => {
    if (invoice.invoice_id && isRequesterApproverDiff) {
      checkSchedulePaymentDate();
    }
  }, [invoice.invoice_id, userInfo.happay_id]);

  const checkSchedulePaymentDate = () => {
    if (
      invoiceScheduleAfterPaymentTime(state.newScheduleDate || payment_date)
    ) {
      setState({
        ...state,
        scheduleDateError: 'Please re-schedule the payment scheduled date.',
      });
      return false;
    }
    return true;
  };

  const checkValidation = () => {
    if (!checkSchedulePaymentDate()) {
      const element = document.querySelector('#invoice-schedule-date');
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return false;
    }
    if (!state.declaration) {
      setState({ ...state, declarationErr: true });
      const element = document.querySelector('#invoice-declaration');
      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return false;
    }
    setState({ ...state, declarationErr: false });
    return true;
  };

  const returnAmountDetail = (
    title,
    key,
    data,
    titleClassName = '',
    dataClassName = '',
  ) => (
    <>
      <Grid
        item
        container
        justify="flex-end"
        className={`font-12 ${titleClassName} fw-500 margin-b-16`}
        xs={18}
      >
        {title}
      </Grid>
      <Grid
        item
        container
        justify="flex-end"
        xs={6}
        className={`margin-b-16 ${dataClassName}`}
      >
        {['GST', 'TDS', 'Discount'].includes(title) && (
          <span className="margin-r-6">{`(${
            title === 'GST' ? '+' : '-'
          })`}</span>
        )}
        {currencyFormatter(data[key], data.currency)}
      </Grid>
    </>
  );

  const checkAmount = () => {
    const { approvedAmount } = state;
    if (name !== 'Payment Scheduled' && !checkSchedulePaymentDate()) {
      return false;
    }
    if (approvedAmount > invoice.amount) {
      const ele = document.querySelector('#approved-amount');
      ele?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
      return false;
    }
    return true;
  };

  const callWorkflowContainerAction = typeOfAction => {
    const { approvedAmount, comment } = state;
    const param = {
      resource_id,
      action_map: JSON.stringify([
        {
          item_id: invoice?.invoice_id,
          action: typeOfAction,
          approved_amount: invoice.payable_amount || invoice.amount,
        },
      ]),
      twfs_id: twf_states?.[0]?.twfs_id,
      is_new_ui: true,
    };
    const commentParam = {
      com_type: 4,
      sub_type: 243,
      twf_id,
      comment,
    };
    let scheduleDateParam;
    if (state.newScheduleDate) {
      scheduleDateParam = {
        invoice_id: invoice.invoice_id,
        schedule_date: formatDate(state.newScheduleDate, 'YYYY-MM-DD'),
      };
    }
    workflowContainerAction(
      param,
      comment ? commentParam : null,
      null,
      scheduleDateParam,
    );
  };

  const onCloseReschedulePayment = () => {
    setState({
      ...state,
      openReschedulePayment: false,
    });
  };

  const onSubmitReschedulePayment = date => {
    rescheduleInvoice({
      invoice_id: invoice.invoice_id,
      schedule_date: formatDate(date, 'YYYY-MM-DD'),
    });
  };

  const handleActionClick = typeofAction => {
    if (typeofAction === 'Reschedule Payment') {
      setState({
        ...state,
        openReschedulePayment: true,
      });
    } else if (typeofAction === 'Cancel Payment') {
      setState({
        ...state,
        openCancelPayment: true,
      });
    } else if (state.newScheduleDate) {
      if (from === 'workflow') {
        callWorkflowContainerAction(typeofAction);
      } else {
        saveAndSubmitInvoice(state.newScheduleDate, invoice.invoice_id);
      }
    } else {
      from === 'workflow'
        ? callWorkflowContainerAction(typeofAction)
        : submitInvoice();
    }
  };

  const onDateChange = (event, date) => {
    setState({
      ...state,
      newScheduleDate: date,
    });
  };

  const onCloseCancelPayment = () => {
    setState({
      ...state,
      openCancelPayment: false,
    });
  };

  const {
    vendor_details: { vendor = {} } = {},
    amount_breakdown = {},
    amount,
    happay_processing_fee,
    approval_status: { name } = {},
    payment_date,
    invoice_id,
  } = invoice || {};
  const {
    openReschedulePayment,
    declaration,
    declarationErr,
    openCancelPayment,
  } = state;
  const { tax_amount = 0, discount = 0, tds_amount = 0 } = amount_breakdown;
  const tdsAmount = tds_amount === null ? "" : tds_amount;
  const taxAmount = tax_amount === null ? "" : tax_amount;
  const { happay_processing_fee_percent = '1.4%' } = userInfo;
  const showPaymentBlock = ['Payment Failed', 'Payment Successful'].includes(
    name,
  );
  return (
    <Grid
      container
      justify="flex-start"
      alignItems="flex-start"
      className="margin-t-118 detail-container"
    >
      <Grid
        item
        className="invoice-upload-container invoice-file-upload"
        xs={24}
        sm={10}
        md={10}
        xl={10}
        lg={10}
      >
        <div className={isMobile ? 'margin-b-20' : 'margin-r-36'}>
          <FileUpload
            id="invoice-detail"
            files={{
              oldFiles: [...(invoice?.attachments || [])],
              newFiles: [],
              deletedFiles: [],
            }}
            multiple
            enableLightBox
            variant="quaternary"
            maxAttachment={5}
            mode="view"
            inplaceUploadWrapper={{ height: '600px' }}
          />
        </div>
      </Grid>

      <Grid item xs={24} sm={14} md={14} xl={14} lg={14}>
        <>
          {istrackWorkflowVisible && (
            <TrackWorkflow
              data={workflowDetails}
              from="invoice"
              getWorkflowComments={getWorkflowComments}
              comment={comment}
            />
          )}
          <ContainerView
            cardTitle="Vendor Detail"
            cardIndex={1}
            type="secondary"
            mappedValues={[
              {
                text: 'Vendor Name',
                key: 'vendor_name',
                type: 'link',
                id: 'vendor_id',
              },
              { text: 'Vendor ID', key: 'vendor_id' },
              { text: 'Display Name', key: 'display_name' },
              {
                text: vendor?.is_gstin_flow ? 'GSTIN' : 'PAN',
                key: 'identification_id',
              },
            ]}
            data={{ ...vendor }}
            className="margin-b-20"
          />
          <ContainerView
            cardTitle="Invoice Details"
            cardIndex={2}
            type="secondary"
            mappedValues={[
              { text: 'Invoice ID', key: 'invoice_ref_id' },
              { text: 'Invoice Description', key: 'description' },
              { text: 'Invoice Date', key: 'invoice_date', type: 'date' },
              {
                text: 'Payment Scheduled Date',
                key: 'payment_date',
                type: 'date',
                edit:
                  name !== 'Payment Scheduled' &&
                  isRequesterApproverDiff &&
                  !isCompleted && !isBlocked
                    ? invoiceScheduleAfterPaymentTime(payment_date)
                    : false,
                error: state.scheduleDateError,
              },
              // { text: 'Created On', key: 'created_on', type: 'date' },
              {
                text: 'Total Invoice Amount',
                key: 'payable_amount',
                type: 'amount',
              },
              { text: 'Last Updated', key: 'last_updated_on', type: 'date' },
              invoiceDetails.approved_amount && {
                text: 'Approved Amount',
                key: 'approved_amount',
                type: 'amount',
              },
            ]}
            data={{ ...invoice }}
            onChange={onDateChange}
            className="margin-b-20"
          />
          {Object.keys(invoice.payment_info).length && showPaymentBlock ? (
            <ContainerView
              cardTitle="Payment Details"
              cardIndex={3}
              type="secondary"
              mappedValues={[
                { text: 'Payment Date', key: 'payment_date', type: 'date' },
                { text: 'Payment Reference ID', key: 'utr' },
                { text: 'Bank Remarks', key: 'bank_remarks' },
              ]}
              data={{ ...invoice.payment_info }}
              className="margin-b-20"
            />
          ) : null}
          <Grid container justify="flex-end" className="margin-tb-30 body">
            {returnAmountDetail('Gross Amount', 'amount', invoice)}
            {returnAmountDetail(
              `GST${+taxAmount ? ` (${decimalFormatter(taxAmount,2)}%)` : ''}`,
              'tax_amount',
              {
                tax_amount: (decimalFormatter(taxAmount,2) * (amount - (discount || 0))) / 100,
              },
            )}
            {returnAmountDetail(
              `TDS${+tdsAmount  ? ` (${decimalFormatter(tdsAmount,2)}%)` : ''}`,
              'tds_amount',
              {
                tds_amount: (decimalFormatter(tdsAmount,2) * (amount - (discount || 0))) / 100,
              },
            )}
            {returnAmountDetail('Discount', 'discount', {
              ...(amount_breakdown || {}),
              ...invoice,
            })}
            {+happay_processing_fee
              ? returnAmountDetail(
                  `Happay Processing Fee @ ${happay_processing_fee_percent} (incl. GST)`,
                  'happay_processing_fee',
                  {
                    ...invoice,
                  },
                  'primary-color',
                  'primary-color',
                )
              : null}
            {returnAmountDetail(
              `Total ${+happay_processing_fee ? 'Payable' : 'Invoice'} Amount`,
              'final_amount',
              invoice,
              'font-14 body dark fw-600',
              'fw-600 body dark',
            )}
          </Grid>

          <Declaration
            onClick={(e, val) =>
              setState({ ...state, declaration: val, declarationErr: !val })
            }
            id="invoice-declaration"
            value={from === 'workflow' ? true : declaration}
            error={declarationErr}
            checkBoxWrapperStyle={
              declarationErr ? { paddingBottom: '60px' } : {}
            }
            disabled={from === 'workflow'}
          />

          <BottomActions
            handleActionClick={handleActionClick}
            actionMap={
              name === 'Payment Scheduled'
                ? {
                    'Cancel Payment': 'Cancel Payment',
                    'Reschedule Payment': 'Reschedule Payment',
                  }
                : item_action_status_map || { Submit: 'Submit' }
            }
            from="Invoice"
            validation={
              from === 'workflow'
                ? checkAmount
                : isRequesterApproverDiff
                ? checkValidation
                : () => {}
            }
            invoiceDetails={invoiceDetails}
            currencyList={currencyList}
            disabled={isBlocked}
            isRequesterApproverDiff={
              name === 'Payment Scheduled' ? true : isRequesterApproverDiff
            }
            viewType={viewType}
          />
        </>

        {name === 'Payment Scheduled' && (
          <>
            <ReschedulePayment
              open={openReschedulePayment}
              onClose={onCloseReschedulePayment}
              onSubmit={onSubmitReschedulePayment}
            />
            <CancelPayment
              invoiceId={invoice_id}
              open={openCancelPayment}
              onClose={onCloseCancelPayment}
            />
          </>
        )}
      </Grid>
    </Grid>
  );
}
